import React from 'react';

class LineamientosDeInformacionTransparente_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Lineamientos de Información Transparente';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_LINEAMIENTOS_INFORMACION_TRANSPARENTE_2024_V1.pdf?alt=media&token=965d961c-e7aa-4c47-806a-9926e324aebe';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default LineamientosDeInformacionTransparente_pdf